import { $GQL } from '@GQL/index';
import type { RoleParams } from '@GQL/index';
import type { Role } from '@nextgenleads/auth-driver';

/**
 * This function will return the available roles formatted for dropdowns
 * @param mpid
 * @param type
 * @param status
 */

export async function getRolesAsOptions(params: RoleParams): Promise<Partial<Role>[]> {
	const query = `
        query GetRolesAsOptions($params: RoleParams!) {
            roles(params: $params) {
                id
                name
                mpid
            }
        }
    `;

	const results = await $GQL.request(query, { params });
	const roles = results.roles;
	const options = roles.map((role: Partial<Role>) => {
		return {
			value: role.id,
			label: role.name,
		};
	});
	return options;
}
